"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconSchoolTestResults = /*#__PURE__*/
function (_Icon) {
  _inherits(IconSchoolTestResults, _Icon);
  function IconSchoolTestResults(props) {
    var _this;
    _classCallCheck(this, IconSchoolTestResults);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconSchoolTestResults).call(this, props));
    _this.name = 'IconSchoolTestResults';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "school-test-results_svg__group0"
    }, _react2.default.createElement("path", {
      className: "school-test-results_svg__path0",
      d: "M1.5 20C.673 20 0 19.327 0 18.5v-17C0 .673.673 0 1.5 0h10.086c.401 0 .777.156 1.06.439l2.914 2.914c.284.284.44.661.44 1.062V12a.5.5 0 01-1 0V5h-2.5c-.827 0-1.5-.673-1.5-1.5V1H1.5a.5.5 0 00-.5.5v17a.5.5 0 00.5.5H12a.5.5 0 010 1H1.5zM12 3.5a.5.5 0 00.5.5h2.293L12 1.207V3.5z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path1",
      d: "M23.5 21.002a.5.5 0 01-.5-.5v-4.263l-3.943 1.579a1.503 1.503 0 01-1.114 0l-4.339-1.735a.624.624 0 01.001-1.161l4.339-1.736a1.503 1.503 0 011.113 0l4.629 1.85a.494.494 0 01.162.108l.019.02a.48.48 0 01.098.156.495.495 0 01.035.18v5.002a.5.5 0 01-.5.5zm-5.186-4.113a.496.496 0 00.372 0l3.468-1.388-3.468-1.386a.495.495 0 00-.372 0l-3.467 1.387 3.467 1.387z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path2",
      d: "M18.842 21.015c-.114 0-.228-.004-.342-.013a4.48 4.48 0 01-3.334-1.129A.506.506 0 0115 19.5V18a.5.5 0 011 0v1.268a3.488 3.488 0 002.5.732l.047.002A3.49 3.49 0 0021 19.268V18a.5.5 0 011 0v1.5a.502.502 0 01-.166.372 4.478 4.478 0 01-2.992 1.143z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path3",
      d: "M23.5 24.002a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path4",
      d: "M3.5 16a.5.5 0 01-.5-.5v-5.002A.5.5 0 013.532 10H4.5c.827 0 1.5.673 1.5 1.5v.5c0 .375-.138.727-.387 1 .249.273.387.625.387 1v.5c0 .827-.673 1.5-1.5 1.5h-1zm1-1a.5.5 0 00.5-.5V14a.5.5 0 00-.5-.5H4V15h.5zm0-2.5A.5.5 0 005 12v-.5a.5.5 0 00-.5-.5H4v1.5h.5z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path5",
      d: "M5.5 9a.5.5 0 01-.5-.5V6.998H4V8.5a.5.5 0 01-1 0v-4C3 3.673 3.673 3 4.5 3S6 3.673 6 4.5v4a.5.5 0 01-.5.5zM5 5.998V4.5a.5.5 0 00-1 0v1.498h1z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path6",
      d: "M8 7.998a.5.5 0 010-1h4.5a.5.5 0 010 1H8z"
    }), _react2.default.createElement("path", {
      className: "school-test-results_svg__path7",
      d: "M8 14.998a.5.5 0 010-1h3a.5.5 0 010 1H8z"
    })));
    return _this;
  }
  return IconSchoolTestResults;
}(_Icon3.default);
exports.default = IconSchoolTestResults;